import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { formatISO } from "date-fns";
import { PassengerPredictionsResponse } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { useMemo } from "react";

export function useAlternativeTransportPlanningPassengerPredictions(
  incidentId: string | null | undefined,
  fromTime: Date | string,
  toTime: Date | string,
): UseQueryResult<AxiosResponse<PassengerPredictionsResponse>> {
  const params = useMemo(
    () => ({
      fromTime: formatISO(fromTime),
      toTime: formatISO(toTime),
    }),
    [fromTime, toTime],
  );

  const passengerPredictionsResponse = useQuery({
    queryKey: [
      "alternativeTransport",
      "passengerPredictions",
      incidentId,
      fromTime,
      toTime,
    ],
    enabled: Boolean(incidentId),
    queryFn: ({ signal }) =>
      axiosClient.get<PassengerPredictionsResponse>(
        `${getBackendUrl()}/alternative-transport-planning/incident/${incidentId}/passenger-predictions`,
        {
          params,
          signal,
        },
      ),
    refetchInterval: 60 * 1000, // Every minute
    retry: false,
  });

  return passengerPredictionsResponse;
}
